export const inputsTitle = ['Модель', 'Марка', 'Год выпуска'];
